import React from 'react';

/**
 * ChartSkeleton — Loading placeholder that matches chart footprint.
 * Renders a pulsing grey block sized to the chart area.
 */
export default function ChartSkeleton({ height = 300, type = 'area' }) {
  return (
    <div
      style={{
        width: '100%',
        height,
        borderRadius: 3,
        background: 'linear-gradient(90deg, var(--neutral-100) 25%, var(--neutral-200) 50%, var(--neutral-100) 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
      {type === 'donut' && (
        <div
          style={{
            width: Math.min(height - 40, 200),
            height: Math.min(height - 40, 200),
            borderRadius: '50%',
            border: '24px solid var(--neutral-200)',
            opacity: 0.5,
          }}
        />
      )}
    </div>
  );
}
